import React from "react";
import RightSideShowSol from "./RightSideShowSol";
import RightSideSelectedFile from "./RightSideSelectedFile";
import { Resizeable } from "./Resizeable";
import { ResizeableContainer } from "./ResizeableContainer";

/**
 * @param props {{
 *  scState:scState
 * }}
 */
export function RightSide({scState}) {
  return <div css={`
          /* background-color:#f6f6fa; */
          /* min-height:100%; */
          overflow:hidden;
          flex:1;
          /* display:flex; */
          /* flex-direction:column; */
          `}>
    <ResizeableContainer direction="column">
      <Resizeable
        defaultWidth={window.innerHeight * 0.4}
        minWidth={100}
        name={"sol"}
        direction="column"
        maxWidth={window.innerHeight-100}
      >
        <div css={`padding:15px;display:flex;flex-direction:column;height:100%;`}>
          <div>
            <RightSideSelectedFile scState={scState} />
          </div>
          <div css={`
          flex:1;
          overflow-y:scroll;
          margin-top:14px;
        `}>
            <RightSideShowSol scState={scState} />
          </div>
        </div>
      </Resizeable>
      <div css={`padding:15px;`}>
        <div css={`background-color:pink;flex:1;`}>
        </div>
      </div>
    </ResizeableContainer>
  </div>
}
